import React from 'react';

import CardHOC from './Components/CardHOC';
import OpenChoice from '../../../Types/Components/OpenChoice';

const OpenChoiceType = ({ index, question }) => {
  return <CardHOC index={index} question={question}>
    <OpenChoice question={question} />
  </CardHOC>
}

export default OpenChoiceType;